module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADZSURBVDhPlZPtEYMgDIaTXodqf5Ut2m2EzeJkNG8giNUqPndcIpJPAuecCaSUitIxTRNX9T9wEGPMIgJ1JbFvHweLcSiEQK9XoHmWjVRHNdSall2NcgnYqClUupkXgzXiPCR7rARNx34i7ZRi/XWO2tK96q1mIiH0ZJTmwBsnUjIIYb95jkgJ0nqwZHARvwW//9FbwXk1zycZMH2eS9d5Zy7NgY6xdb8fGjP8NdCYGyeajQlffQnvhw2LEamMOyTwEtpM+7rag/YaHbzK0TnAuY0DZl5vHEL0BavKUQ509W5nAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/PROGMENU.png
// module id = 90
// module chunks = 0